import { render, staticRenderFns } from "./validate-email-sended.vue?vue&type=template&id=040e87b6&scoped=true"
import script from "./validate-email-sended.vue?vue&type=script&lang=js"
export * from "./validate-email-sended.vue?vue&type=script&lang=js"
import style0 from "./validate-email-sended.vue?vue&type=style&index=0&id=040e87b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e87b6",
  null
  
)

export default component.exports